import React from 'react';
import { Pagination } from '@mui/material';

const PaginationComponent = ({ count, page, onChange }) => {
  return (
    <Pagination
      count={count}
      page={page}
      onChange={onChange}
      variant="outlined"
      shape="rounded"
      sx={{
        '& .MuiPaginationItem-root': {
          color: '#202020',
          borderRadius: '10px',
          height: '40px',
          width: '40px',
          fontSize: '18px',
          fontWeight: 700,
        },
        '& .MuiPaginationItem-root:hover': {
          backgroundColor: '#EAECF0',
        },
        '& .MuiPaginationItem-page.Mui-selected': {
          backgroundColor: '#414141',
          borderRadius: '10px',
          color: 'white',
        },
        '& .MuiPaginationItem-page.Mui-selected:hover': {
          backgroundColor: '#555555',
        },
      }}
    />
  );
};

export default PaginationComponent;
